<!-- template html -->
<template>
    <GroupCardCarousel v-show="this.collection" :collection="this.collection" :displayScaleBar="false" :isContributor="true" />
    <!-- GroupCardCarousel component -->
</template>
<!-- template html -->
<!-- script -->
<script>
   import GroupCardCarousel from './GroupCardCarousel.vue';

    export default {
        name: 'GroupCardContributorMain',
        components: {
            GroupCardCarousel
        },
      props: ['collection'],
        data: function () {
            return {
            }
        },
        mounted: function () {
            
        },
        methods: {
        }
    }
</script>
<!-- script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>